module.exports = __webpack_public_path__ + "static/media/proj3.31a669c2.png";